export const BASE_URL = "https://admin.duhipaints.com";
// export const BASE_URL = "http://localhost:8000";


export const APILogInIfo = BASE_URL + "/api/login-info";

// User Management
export const APIUserStats = BASE_URL + "/api/user/stats";
export const APIUserStore = BASE_URL+"/api/user/store";
export const APIUserList = BASE_URL+"/api/user/list";
export const APIUserNames = BASE_URL+"/api/user/names";
export const APIUserLogin = BASE_URL+"/api/user/login";
export const APIUserLogout = BASE_URL+"/api/user/logout";
export const APIUserUpdate = BASE_URL+"/api/user/update";
export const APIUserDelete = BASE_URL+"/api/user/delete";
export const APIUserUpdatePassword = BASE_URL+"/api/user/update/password";


// Company
export const APICompanyList = BASE_URL + "/api/company/list";
export const APICompanyStore = BASE_URL + "/api/company/store";
export const APICompanyShow = BASE_URL + "/api/company/show/";
export const APICompanyUpdate = BASE_URL + "/api/company/update";
export const APICompanyDelete = BASE_URL + "/api/company/delete";
export const APICompanyNames = BASE_URL + "/api/company/names";
export const APICompanyConfig = BASE_URL + "/api/company/config";



// export const APIContactStore = BASE_URL +'/api/contact/contact';
export const APIContactList = BASE_URL + '/api/contact/list';
export const APIContactShow = BASE_URL + '/api/contact/show';
export const APIContactReply = BASE_URL + '/api/contact/reply';
export const APIContactStatus = BASE_URL + '/api/contact/status';
export const APIContactDelete = BASE_URL + '/api/contact/delete';
export const APIContactStats = BASE_URL + '/api/contact/stats';